<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="pubitCssCls1"><span class="pubitCssCls2">L. D.</span></p>
<p class="pubitCssCls1"><span class="pubitCssCls3">Knorr</span></p>
<p class="pubitCssCls4"><span class="pubitCssCls5"> </span></p>
<p class="pubitCssCls4"><span class="pubitCssCls5"> </span></p>
<p class="pubitCssCls4"><span class="pubitCssCls5"> </span></p>
<p class="pubitCssCls1"><span class="pubitCssCls6">The</span></p>
<p class="pubitCssCls1"><span class="pubitCssCls7">Leviticus Mission</span></p>
<p class="pubitCssCls1"><span class="pubitCssCls8"> </span></p>
<p class="pubitCssCls1"><span class="pubitCssCls9">The RV Mysteries</span></p>
<p class="pubitCssCls1"><span class="pubitCssCls9">Book ONE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fa34bd67ba7d478ea498a017dfec88b8.vue?2028d81e